import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";

export default KeyValuePairsTable;

function KeyValuePairsTable(props) {
  const { keyValuePairs, onKeyValuePairEdit, onKeyValuePairRemove } = props;

  const keys = Object.keys(keyValuePairs ?? {});

  if (keys.length === 0) return null;

  return (
    <Table dense>
      <TableHead>
        <TableHeader>Key</TableHeader>
        <TableHeader>Value</TableHeader>
        <TableHeader>Actions</TableHeader>
      </TableHead>
      <TableBody>
        {keys.map((key, idx) => {
          const value = keyValuePairs[key];

          return (
            <TableRow key={idx}>
              <TableCell>{key}</TableCell>
              <TableCell>{value}</TableCell>
              <TableCell>
                <Button
                  plain
                  onClick={() => onKeyValuePairEdit(key, value)}
                >
                  <PencilIcon />
                </Button>
                <Button
                  plain
                  onClick={() => onKeyValuePairRemove(key)}
                >
                  <TrashIcon />
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
